import { defineField, defineType } from "sanity";

export const classContentType = defineType({
  type: "document",
  name: "classContent",
  title: "Class Content",
  fields: [
    // title
    defineField({
      name: "name",
      type: "string",
      title: "Name",
      validation: (Rule) => Rule.required()
    }),
    // subtitle
    defineField({
      name: "subtitle",
      type: "string",
      title: "Subtitle"
    }),
    defineField({
      name: "taskGroupReference",
      type: "string",
      title: "Task Group"
    }),
    defineField({
      name: "colorScheme",
      type: "string",
      title: "Color Scheme",
      description:
        "Visual theme for the module header. Keep consistent across language versions of the same class.",
      options: {
        list: [
          { title: "Golden Hour", value: "goldenHour" },
          { title: "Hazy Sundown", value: "hazySundown" },
          { title: "Fierce Sundown", value: "fierceSundown" },
          { title: "Sunrise", value: "sunrise" },
          { title: "Mid Morning", value: "midMorning" },
          { title: "Afternoon", value: "afterNoon" }
        ],
        layout: "dropdown"
      }
    }),
    // list of lessons
    defineField({
      name: "listOfLessons",
      type: "array",
      of: [{ type: "reference", to: [{ type: "lessonContent" }] }],
      title: "List of Lessons"
    }),
    // list of educational content
    defineField({
      name: "listOfEducationalContent",
      type: "array",
      of: [{ type: "reference", to: [{ type: "educationalContent" }] }],
      title: "List of Educational Content Items"
    }),
    // language
    defineField({
      name: "language",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required()
    })
  ],

  preview: {
    select: {
      name: "name",
      slug: "taskGroupReference"
    },
    prepare(selection) {
      const { name } = selection;
      return {
        title: name
      };
    }
  }
});
